export default __webpack_public_path__ + "static/media/Oswald-Regular.61b8c47b.ttf";